<div [@routerTransition]>
    <sub-header [title]="'AddStockItem' | localize" [description]="this.stockTakeHeaderinfo">
        <div role="actions">
            <!--<button
                id="btn_create_StockTake"
                *ngIf="'Pages.StockTake.Create' | permission"
                (click)="createStockTake()"
                class="btn btn-primary blue"
            >
                <i class="fa fa-plus"></i>
                {{ l('CreateNewStockTake') }}
            </button>-->
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row mt-3">
                    <div class="col-md-7">
                        <div class="form-group">
                            <label for="StockTakeDetail_ReferenceNo">{{ l('Code') }}</label>
                            <input type="text" id="stockTakeDetail_ProductCode"
                                   class="form-control" [(ngModel)]="stockTakeDetail.productCode" name="ProductCode"
                                   (blur)="searchProduct(stockTakeDetail.productCode)" (keydown.enter)="searchProduct(stockTakeDetail.productCode)"/>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <div class="form-group">
                            <label for="StockTakeDetail_ReferenceNo">{{ l('ProductName') }}</label>
                            <app-search-product (productEvent)="getProduct($event)" [productSelectedItem]="stockTakeDetail.productSelectedItem"> </app-search-product>
                        </div>
                    </div>
                        <div class="col-md-7">
                            <div class="form-group">
                                <label for="StockTakeDetail_SystemQty">{{ l('SystemQty') }}</label>
                                <input type="text" id="stockTakeDetail_SystemQty" disabled="disabled"
                                       class="form-control" [(ngModel)]="stockTakeDetail.systemQty" name="SystemQty" />
                            </div>
                        </div>
                        <div class="col-md-7">
                            <div class="form-group">
                                <label for="StockTakeDetail_UnitName">{{ l('UnitName') }}</label>
                                <input type="text" id="stockTakeDetail_UnitName" disabled="disabled"
                                       class="form-control" [(ngModel)]="stockTakeDetail.unitName" name="UnitName" />
                            </div>
                        </div>
                        <div class="col-md-2">
                            &nbsp;
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="StockTakeDetail_ScannedQty">{{ l('ScannedQty') }}</label>
                                <input type="text" id="stockTakeDetail_UnitName" [(ngModel)]="scannedQty" disabled="disabled"
                                       class="form-control" name="ScannedQty" />
                            </div>
                        </div>
                        <div class="col-md-1">
                            <div class="form-group">
                                <label for="StockTakeDetail_ScannedQty">&nbsp;</label>
                                <button class="btn btn-primary mt-5" type="button">
                                    <i class="flaticon2-plus-1"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="StockTakeDetail_PhysicalQty">{{ l('PhysicalQty') }}</label>
                                <input type="text" id="stockTakeDetail_PhysicalQty"
                                       class="form-control" name="PhysicalQty" [(ngModel)]="stockTakeDetail.physicalQty" />
                            </div>
                        </div>
                    </div>
                <br />
                <div class="card-footer" *ngIf="this.stockTake.status == this.status.Draft">
                    <div class="col-lg-12 text-end">
                        <button class="btn btn-danger me-2" (click)="clear()">
                            <i class="fa fa-close"></i>
                            stockTake.status
                            <span>{{ l('Clear') }}</span>
                        </button>
                        <button  class="btn btn-primary blue me-2" (click)="save()" [buttonBusy]="saving">
                            <i class="fa fa-save"></i>
                            <span>{{ l('Add') }}</span>
                        </button>
                    </div>
                </div>
                <form class="form" autocomplete="off">
                    <div>
                        <div class="row align-items-center">
                            <div class="col-xl-12">
                                <div class="my-3">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="filterText"
                                               (ngModelChange)="getStockTakes()"
                                               name="filterText"
                                               autoFocus
                                               type="text"
                                               class="form-control"
                                               [placeholder]="l('SearchWithThreeDot')" />
                                        <button class="btn btn-primary" type="submit" (click)="getStockTakes()">
                                            <i class="flaticon-search-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" [hidden]="!advancedFiltersAreShown">
                            <div class="col-md-12"></div>

                            <div class="col-md-12 mt-5">
                                <button (click)="resetFilters()"
                                        class="btn btn-secondary btn-sm"
                                        id="btn-reset-filters">
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table #dataTable
                                 (onLazyLoad)="getStockTakes($event)"
                                 [value]="primengTableHelper.records"
                                 rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                                 [paginator]="false"
                                 tableStyleClass="table table-bordered table-hover"
                                 [lazy]="true"
                                 [scrollable]="true"
                                 ScrollWidth="100%"
                                 [tableStyle]="{ 'min-width': '50rem' }"
                                 [resizableColumns]="primengTableHelper.resizableColumns">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.StockTakes.Edit', 'Pages.StockTake.Delete')">
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="StockTakeNo">
                                        {{ l('Code') }}
                                        <p-sortIcon field="StockTake.stockTakeNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="StockTakeDate">
                                        {{ l('ProductName') }}
                                        <p-sortIcon field="StockTake.stockTakeDate"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="SystemQty">
                                        {{ l('SystemQty') }}
                                        <p-sortIcon field="StockTake.systemQty"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="PhysicalQty">
                                        {{ l('PhysicalQty') }}
                                        <p-sortIcon field="StockTake.physicalQty"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="TotalVarianceQty">
                                        {{ l('VarianceQty') }}
                                        <p-sortIcon field="StockTake.varianceQty"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="UnitName">
                                        {{ l('UnitName') }}
                                        <p-sortIcon field="StockTake.unitName"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.StockTakes.Edit', 'Pages.StockTake.Delete')">
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a href="javascript:;"
                                                       class="dropdown-item"
                                                       (click)="
                                                            editStockTakeDetailModal.show(stockTakeId,record.productId)
                                                        ">
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       (click)="deleteStockTakeDetailItem(record)">
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Code') }}</span>
                                        {{ record.productCode }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('ProductName') }}</span>
                                        {{ record.productName }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('SystemQty') }}</span>
                                        {{ record.systemQty }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('PhysicalQty') }}</span>
                                        {{ record.physicalQty }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('VarianceQty') }}</span>
                                        {{ record.varianceQty }}
                                    </td>
                                    <td style="width: 150px" class="text-center">
                                        <span class="p-column-title" >{{ l('UnitName') }}</span>
                                        {{ record.unitName }}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                         #paginator
                                         (onPageChange)="getStockTakes($event)"
                                         [totalRecords]="primengTableHelper.totalRecordsCount"
                                         [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                         [showCurrentPageReport]="true"
                                         [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>
    <editStockTakeDetailModal #editStockTakeDetailModal
                              (modalSave)="getStockTakes()"></editStockTakeDetailModal>
</div>
